import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

//import constants
import { AppSettings } from '../../../constants/app-settings';
import { AppPermissions } from '../../../constants/app-permission';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;

  tabActive = 'tab1';

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {

    let tab = this.route.snapshot.paramMap.get('tab');
    
    if (tab && tab == '2')
      this.tabActive = 'tab2';

  }

}
